export var PLAN_TYPES = {
  INDIVIDUAL: 'INDIVIDUAL',
  TEAMS: 'TEAMS',
  AUDIENCE: 'AUDIENCE'
};
export var PACKAGE_IDS = {
  STANDARD_MONTHLY: 31,
  STANDARD_ANNUAL: 32,
  ADVANTAGE: 34,
  PREMIER: 36,
  TEAMS_ADVANTAGE: 134,
  TEAMS_PREMIER: 136,
  ENTERPRISE: 26,
  ANALYZE: 37
};
export var INDIVIDUAL_PLAN_IDS_WITH_MONTHLY = [PACKAGE_IDS.PREMIER, PACKAGE_IDS.ADVANTAGE, PACKAGE_IDS.STANDARD_MONTHLY];
export var INDIVIDUAL_PLAN_IDS_ANNUAL = [PACKAGE_IDS.PREMIER, PACKAGE_IDS.ADVANTAGE, PACKAGE_IDS.STANDARD_ANNUAL];
export var TEAMS_PLAN_IDS = [PACKAGE_IDS.ENTERPRISE, PACKAGE_IDS.TEAMS_ADVANTAGE, PACKAGE_IDS.TEAMS_PREMIER];
export var STARTER_ANNUAL_V2_INDIVIDUAL = [
// GROW_1898_STARTER_ANNUAL_V2
PACKAGE_IDS.PREMIER, PACKAGE_IDS.ADVANTAGE, PACKAGE_IDS.STANDARD_ANNUAL, PACKAGE_IDS.STANDARD_MONTHLY];